import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { ValuesMarquee } from "./components/ValuesMarquee";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { NuevoIngreso } from "./components/NuevoIngreso";
import { Tramites } from "./components/Tramites";
import { Becas } from "./components/Becas";
import { SectionGrid } from "./components/SectionGrid";
import { Flyers } from "./components/Flyers";
import { FAQ } from "./components/FAQ";
import { Ubicaciones } from "./components/Ubicaciones";
import { EXTRACURRICULARES, SALUD, ADICIONALES, ESTADIAS } from "./data/content";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-[#FAFAFA]">
      <Toaster position="top-right" richColors />
      <Header />
      <main>
        <Hero />
        <ValuesMarquee />
        <About />
        <Services />
        <NuevoIngreso />
        <Tramites />
        <Becas />
        <SectionGrid id="estadias" testid="estadias-section" data={ESTADIAS} />
        <SectionGrid id="extracurriculares" testid="extracurriculares-section" data={EXTRACURRICULARES} />
        <SectionGrid id="salud" testid="salud-section" data={SALUD} muted />
        <SectionGrid id="adicionales" testid="adicionales-section" data={ADICIONALES} />
        <Flyers />
        <FAQ />
        <Ubicaciones />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
